<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm>
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <CInput
                  placeholder="Email Address"
                  autocomplete="username email"
                  v-model="email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                  v-model="password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="primary" @click="handleSubmit" class="px-4">Login</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                    <CButton color="secondary" class="px-0" @click="handleForgotPassword">Forgot password?</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Login', 
  data(){
            return {
                loginError : false,
                email : "",
                password : ""
            }
        },
        methods : {
          handleForgotPassword(e) {
            console.log("Forgot password clicked")
            e.preventDefault();
            this.$router.push("/pages/forgot");
          },
            handleSubmit(e){
                e.preventDefault()
                var self = this;
                var router = router;
                if (this.password.length > 0) {
                    this.$http.post(this.$apiUrl + '/login', {
                        username: this.email,
                        password: this.password
                    })
                    .then(response => {
                        localStorage.setItem('session_id', response.data.sessionID);
                        localStorage.setItem('user', response.data.user)
                        console.log(response);
                        self.$router.push('/Dashboard')
                    })
                    .catch(function (error) {
                        this.$snotify.error("Invalid Username or Password");
                        
                        console.error(error.response);
                    });
                }
            }
        }
}
</script>
